import { set, toggle } from '@/utils/vuex'

export default {
  setLoginInfo : set('loginInfo'),
  setCartInfo : set('cartInfo'),
  //toggleDrawer: toggle('drawer')
  setAroApplyResult : set('aroApplyResult'),
  setAroNtcApplyResult : set('aroNtcApplyResult'),
  setMemberBirthDt : set('memberBirthDt')
}



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js